import React, { Component } from 'react';

class Smooth extends Component {
  constructor(props) {
    super(props);
    this.state = {valors:0};
  }

  sliderAction(e){
    const cv = window.cv;
    let temporal=e.target.valueAsNumber;
    this.setState({ valors:  temporal});


    let imgElement = document.getElementById(this.props.inputImg);
    let src = cv.imread(imgElement);
    let dst = new cv.Mat();
    let ksize = new cv.Size(temporal, temporal);
    let anchor = new cv.Point(-1, -1);
    // You can try more different parameters
    cv.blur(src, dst, ksize, anchor, cv.BORDER_DEFAULT);
    // cv.boxFilter(src, dst, -1, ksize, anchor, true, cv.BORDER_DEFAULT)
    cv.imshow('canvasOutput1', dst);
    src.delete(); dst.delete();
  }
  render() {
    return (
      <div className="Smooth">
        <h1>Smooth</h1>
        <input type="range" onChange={(e)=>this.sliderAction(e)} min="1" max="10"/><span>salida: {this.state.valors}</span>
        <br/>
        <canvas id="canvasOutput1"></canvas>

      </div>
    );
  }
}

export default Smooth;
